<template>
  <ModalProvider
    v-for="modal in modalsStore.modals"
    :key="modal.id"
    :modal-id="modal.id"
  >
    <component
      :is="modal.component"
      :data="modal.data"
    />
  </ModalProvider>
</template>

<script setup lang="ts">
import ModalProvider from '@/components/modal/ModalProvider.vue'
import { useModalsStore } from '@/stores/modals-store'

const modalsStore = useModalsStore()
</script>
